import React from 'react'
import { useIntl } from 'react-intl'
import { Box, MenuItem, Select } from '@mui/material'
import { ui } from '../../utils/uiTokens'

// Те же диапазоны, что в EditCourseTopicScheduleDialog: другими темы не размечают
const MONTHS = [1, 2, 3, 4, 5]
const WEEKS = [1, 2, 3, 4]

interface Props {
    monthNumber?: number
    weekNumber?: number
    onChange: (monthNumber?: number, weekNumber?: number) => void
}

const styles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
    },
    select: {
        minWidth: 150,
        borderRadius: ui.radius,
        fontSize: '13.5px',
        fontWeight: 600,
        color: ui.ink,
        backgroundColor: ui.card,
        '& .MuiOutlinedInput-notchedOutline': { borderColor: ui.border },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: ui.pink },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: ui.pink },
    },
    weeks: {
        display: 'flex',
        gap: 0.75,
        flexWrap: 'wrap',
    },
    weekTab: (active: boolean) => ({
        padding: '8px 14px',
        borderRadius: ui.radius,
        cursor: 'pointer',
        userSelect: 'none',
        fontSize: '13.5px',
        lineHeight: 1.2,
        fontWeight: active ? 600 : 400,
        color: active ? ui.pink : ui.sub,
        backgroundColor: active ? ui.pinkSoft : 'transparent',
        border: `1px solid ${active ? 'transparent' : ui.border}`,
        transition: 'background-color 0.15s ease, color 0.15s ease',
        '&:hover': { borderColor: ui.pink, color: ui.pink },
    }),
}

const MonthWeekFilter: React.FC<Props> = ({
    monthNumber,
    weekNumber,
    onChange,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box sx={styles.wrapper}>
            <Select
                size="small"
                displayEmpty
                value={monthNumber ?? ''}
                onChange={(e) =>
                    onChange(Number(e.target.value) || undefined, weekNumber)
                }
                sx={styles.select}
            >
                <MenuItem value="">
                    {formatMessage({ id: 'allMonths' })}
                </MenuItem>
                {MONTHS.map((month) => (
                    <MenuItem key={month} value={month}>
                        {month} {formatMessage({ id: 'month' })}
                    </MenuItem>
                ))}
            </Select>

            <Box sx={styles.weeks}>
                <Box
                    sx={styles.weekTab(!weekNumber)}
                    onClick={() => onChange(monthNumber, undefined)}
                >
                    {formatMessage({ id: 'allWeeks' })}
                </Box>

                {WEEKS.map((week) => (
                    <Box
                        key={week}
                        sx={styles.weekTab(week === weekNumber)}
                        onClick={() => onChange(monthNumber, week)}
                    >
                        {week} {formatMessage({ id: 'week' })}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default MonthWeekFilter
